import { Item, ItemType } from './types';
import i18n from '../i18n';

// 初始道具数量配置
export const INITIAL_ITEMS_COUNT = 2;

// 复活卡恢复的行动点数量
export const REVIVE_MOVES_AMOUNT = 15;

// 获取道具配置（使用函数确保翻译能够随语言变化而更新）
export const getItemsConfig = (): Item[] => [
  {
    type: ItemType.RESET,
    count: INITIAL_ITEMS_COUNT,
    icon: '🔄',
    name: i18n.t('items.config.reset.name'),
    description: i18n.t('items.config.reset.description')
  },
  {
    type: ItemType.SWAP,
    count: INITIAL_ITEMS_COUNT,
    icon: '⇄',
    name: i18n.t('items.config.swap.name'),
    description: i18n.t('items.config.swap.description')
  },
  {
    type: ItemType.UPGRADE,
    count: INITIAL_ITEMS_COUNT,
    icon: '⬆️',
    name: i18n.t('items.config.upgrade.name'),
    description: i18n.t('items.config.upgrade.description')
  },
  {
    type: ItemType.RECOVER,
    count: INITIAL_ITEMS_COUNT,
    icon: '💊',
    name: i18n.t('items.config.recover.name'),
    description: i18n.t('items.config.recover.description')
  },
  {
    type: ItemType.REVIVE,
    count: INITIAL_ITEMS_COUNT,
    icon: '💫',
    name: i18n.t('items.config.revive.name'),
    description: i18n.t('items.config.revive.description')
  }
];

// For backward compatibility, keep static configuration (but initialize with function)
export const ITEMS_CONFIG = getItemsConfig();

// 行动恢复值
export const RECOVER_MOVES_AMOUNT = 3;

// 升级器增加的值
export const UPGRADE_AMOUNT = 2;